var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadMoreArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.750244 0.291559L0.750244 6.70844C0.750266 6.76156 0.764794 6.81367 0.792261 6.85914C0.819727 6.90461 0.85909 6.94171 0.9061 6.96645C0.953111 6.99118 1.00598 7.00261 1.05901 6.9995C1.11204 6.99639 1.16322 6.97885 1.20701 6.94878L5.87383 3.74034C5.91282 3.71354 5.94469 3.67765 5.96672 3.63578C5.98874 3.59391 6.00025 3.54731 6.00025 3.5C6.00025 3.45269 5.98874 3.40609 5.96672 3.36422C5.94469 3.32235 5.91282 3.28646 5.87383 3.25966L1.20701 0.0512175C1.16322 0.021151 1.11204 0.00361441 1.05901 0.000501142C1.00598 -0.00261165 0.953111 0.00881671 0.9061 0.0335526C0.85909 0.058289 0.819727 0.0953932 0.79226 0.140862C0.764793 0.186331 0.750265 0.238438 0.750244 0.291559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMoreArrow);
export default __webpack_public_path__ + "static/media/load_more_arrow.e0be955b3c16e8a222904cf41f3202eb.svg";
export { ForwardRef as ReactComponent };